<template>
    <div>
        <el-dialog :visible.sync="auditFormDialog.dialogVisible"
                   :append-to-body="true"
                    :width="auditFormDialog.width">
            <el-form>
                <el-form-item label="操作">
                    <el-select v-model="auditFormDialog.selectedValue" placeholder="请选择">
                        <el-option
                        v-for="item in options"
                        :label="item.label"
                        :value="item.value"
                        :key="item.value">

                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="auditFormDialog.dialogVisible = false">确 定</el-button>
                <el-button @click="auditFormDialog.dialogVisible = false">取 消</el-button>

            </div>
        </el-dialog>
    </div>

</template>

<script>
export default {
    data(){
        return {
            selectedValue: '',
            options: [
                {
                    value: 0,
                    label: '审核通过'
                },
                {
                    value: 1,
                    label: '审核不通过'
                },{
                    value: 2,
                    label: '撤回上一步'
                }
            ]
        }
    },
    props: ['auditFormDialog']

}


</script>